import { formatDateWithCurrentTime } from './standardizedDate'

export const formattedDate = (date: string) => {
  return formatDateWithCurrentTime(date)
}
